import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import {app} from './translations/translation.it.json'

const options = {
    interpolation: {
        escapeValue: false,
    },
    debug: false,
    resources: {
        it: {
            app,
        },
    },
    fallbackLng: 'it',
    ns: ['app'],
    react: {
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
        useSuspense: true,
    },
}

i18n.use(initReactI18next).init(options)

export default i18n
